import '../../base/buttons/as-icon-button';
import styleText from './as-home-button.css?raw';

export class AsHomeButton extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsHomeButton.sheet
    ];

    this.shadowRoot!.innerHTML = /*html*/`
      <as-icon-button
        name="home"
        black
        file-name="header/apps.png"
        tooltip-dict-key="tooltip.apps.home"
        tooltip-default-text="Back to App Suite"
        tooltip-placement="bottom-right"
      ></as-icon-button>
    `;
  }
}

customElements.define('as-home-button', AsHomeButton);
